import { getTitleValidator } from 'validators';
import { isLastDayOfMonth } from "../billing-day-of-month/selectors";
import { maxChargesLimit as maxChargesSelector, maxChargesEnabled } from "./selectors";
import { serviceModel } from '..';
export function validate(service) {
  return validateMaxCharges(service).concat(validateDayOfMonth(service));
}
export function validateDayOfMonth(service) {
  const billingDayOfMonth = serviceModel.billingDayOfMonth(service);
  const isBilledUpfront = serviceModel.isBilledUpfront(service);
  if (!billingDayOfMonth || isBilledUpfront == null) return [];
  return validateBillingDayOfMonth(billingDayOfMonth, isBilledUpfront) ? ['billed upfront on last day of month'] : [];
}
export function validateMaxCharges(service) {
  const maxCharges = maxChargesSelector(service);
  const isMaxChargesEnabled = maxChargesEnabled(service);

  if (isMaxChargesEnabled) {
    if (maxCharges == null) {
      return ['max charges is empty'];
    } else if (maxCharges < 1 || maxCharges > 99) {
      return ['max charges not in valid range (1 >= maxCharges <= 99)'];
    }
  }

  return [];
}
export function validateName(name, nameBlacklist) {
  const trimmed = name.trim();

  if (!trimmed) {
    return 'Service name is required';
  }

  if (nameBlacklist && nameBlacklist.includes(trimmed)) {
    return 'You already use this service name';
  }

  const validation = getTitleValidator('Service name')(name);

  if (validation !== true) {
    return typeof validation === 'string' ? validation : 'Service name is invalid';
  }

  return undefined;
}
export function isInvalid(service) {
  return validate(service).length > 0;
}
/** Will return true if there's an error. */

export const validateBillingDayOfMonth = (billingDayOfMonth, isBilledUpfront) => {
  return isLastDayOfMonth(billingDayOfMonth) && isBilledUpfront;
};